export default __webpack_public_path__ + "static/OYOY-1024x208-60fps-2d47c53565448392af3b4fc925e64ad8.mp4";